import CompanyStatusesComponent from './companyStatusesComponent';
import CompanyStatusesContainer from './companyStatusesContainer';

export default CompanyStatusesContainer(CompanyStatusesComponent);
